import withLocalLoader from 'components/HOCs/withLocalLoader';
import { connect } from 'react-redux';
import { getMarketingAssets } from 'state/actions/actions';
import ContentLibrary from 'tailwind-components/ContentLibrary/ContentLibrary';

function mapStateToProps({ marketingAssets }) {
  return {
    marketingAssets: marketingAssets.data
  };
}

export default connect(mapStateToProps, { getMarketingAssets })(
  withLocalLoader(ContentLibrary, true, 'Marketing Services', 'Content Library')
);
